import React, { useState } from "react";
import classes from "./ColumnOptionsOverlay.scss";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { AddColumnOutlined, DeleteOutlined } from "@toddle-edu/ds-icons";
import { elevations } from "@toddle-edu/ds-theme";
import PropTypes from "prop-types";
import { Dialog } from "@toddle-edu/ds-web";

// component to add cols to left or right, or delete cols.
const ColumnOptionsOverlay = React.memo(
  ({ deleteCol, index, id, addCol, t, testId }) => {
    const addColBefore = () => addCol(index);
    const addColAfter = () => addCol(index + 1);
    const deleteColIndex = () => deleteCol(id);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const toggleDeleteDialog = () => {
      setShowDeleteDialog(!showDeleteDialog);
    };

    return (
      <div className={classes.container} style={elevations["elevation-2B"]}>
        <Tooltip tooltip={t("project:add_column_to_left")}>
          <IconButton
            icon={<AddColumnOutlined />}
            type="plain"
            variant="neutral"
            onMouseDown={addColBefore}
            // same icon rotated 180deg
            className={classes.reverseY}
            size="small"
            testId={`${testId}-ColumnOptionsOverlay-AddColBefore`}
          ></IconButton>
        </Tooltip>
        <Tooltip tooltip={t("project:add_column_to_right")}>
          <IconButton
            icon={<AddColumnOutlined />}
            type="plain"
            variant="neutral"
            onMouseDown={addColAfter}
            size="small"
            testId={`${testId}-ColumnOptionsOverlay-AddColAfter`}
          ></IconButton>
        </Tooltip>
        <div className={classes.divider} />
        <Tooltip tooltip={t("project:delete_column")}>
          <IconButton
            icon={<DeleteOutlined />}
            type="plain"
            variant="neutral"
            onMouseDown={toggleDeleteDialog}
            size="small"
            testId={`${testId}-ColumnOptionsOverlay-DeleteCol`}
          ></IconButton>
        </Tooltip>
        {showDeleteDialog ? (
          <Dialog
            title={t("common:delete_with_label", {
              label: t(`common:column`),
            })}
            message={t("project:delete_warning_with_label", {
              label: t(`common:column`),
            })}
            buttonOneText={t("common:cancel")}
            buttonTwoText={t("common:delete")}
            onButtonOneClick={toggleDeleteDialog}
            onButtonTwoClick={deleteColIndex}
            isClosable={true}
            onClose={toggleDeleteDialog}
            testId={`${testId}-ColumnOptionsOverlay-DeleteDialog`}
            dsVersion="2.0"
          />
        ) : null}
      </div>
    );
  }
);

ColumnOptionsOverlay.displayName = "ColumnOptionsOverlay";

ColumnOptionsOverlay.propTypes = {
  deleteCol: PropTypes.func,
  addCol: PropTypes.func,
  index: PropTypes.number,
  testId: PropTypes.string,
};
export default ColumnOptionsOverlay;
